import React from "react"
import { useParams } from "react-router-dom"
import { Edit } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { ScheduleForm } from "components/schedule"

function ScheduleEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { objectid } = useParams<{ objectid: string }>()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "objects", id: objectid, icon: <ScheduleIcon/> },
    ]

    return (
        <Edit title={translate('resources.schedules.edit')}
            resource={`schedules`} 
            mutationMode="pessimistic"
            redirect={`/objects/${objectid}/schedules`}
            actions={<RecordActionsTabs subTabs={subTabs} resourceParent="objects" resourceParentId={objectid} />} 
        >
            <ScheduleForm />
        </Edit>
    )
}

export default ScheduleEdit